import Plyr from 'plyr';
import Flickity from 'flickity';

declare const galleryData: string;

class FF_FlexGallery extends HTMLElement {
	hovering = false;
	index = 0;
	hoverIndex = 0;
	players: { plyr: Plyr }[] = [];
	playingVideo = 0;
	flkty!: Flickity;
	data: {
		id: string;
		title: string;
		body: string;
		video: string;
	}[];

	DOM: {
		next: HTMLButtonElement | null;
		prev: HTMLButtonElement | null;
		controlPanel: HTMLElement | null;
		dots: NodeListOf<HTMLElement>;
		hoverTitle: HTMLElement | null;
		rotator: HTMLElement | null;
		slides: NodeListOf<HTMLElement>;
	} = {} as any;

	constructor() {
		super();
		this.data = JSON.parse(galleryData);
		this.cache();
		this.events();
		// this.initVideos()
		this.initRotator();
	}

	cache() {
		this.DOM = {
			next: this.querySelector('.js-next'),
			prev: this.querySelector('.js-prev'),
			controlPanel: this.querySelector('.js-controlPanel'),
			dots: this.querySelectorAll('.js-dot'),
			hoverTitle: this.querySelector('.js-hoverTitle'),
			rotator: this.querySelector('.js-rotator'),
			slides: this.querySelectorAll('.js-slide'),
		};
	}

	events() {
		this.DOM.prev?.addEventListener('click', this.prevClick.bind(this));
		this.DOM.next?.addEventListener('click', this.nextClick.bind(this));
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].addEventListener('click', this.dotClick.bind(this, i));
			this.DOM.dots[i].addEventListener('mouseenter', this.dotEnter.bind(this, i));
		}
		this.DOM.controlPanel?.addEventListener('mouseenter', this.controlEnter.bind(this));
		this.DOM.controlPanel?.addEventListener('mouseleave', this.controlLeave.bind(this));
	}

	initVideos() {
		for (let i = 0; i < this.DOM.slides.length; i++) {
			const el = this.DOM.slides[i].querySelector('.js-video');
			let plyr;
			if (el instanceof HTMLElement) {
				plyr = new Plyr(el, {
					controls: ['play'],
					loop: { active: true },
					iconUrl: `${templateDirectoryUri}/partials/ember/plyr.svg`,
				});
				if (i === 0) {
					plyr.muted = true; //this is weirdly needed
				} else {
					plyr.muted = false;
				}
			}
			this.players.push({
				plyr: plyr as Plyr,
			});
		}
	}

	initRotator() {
		if (!this.DOM.rotator) return;
		this.flkty = new Flickity(this.DOM.rotator, {
			pageDots: false,
			prevNextButtons: false,
		});
		this.flkty.on('change', this.rotatorChange.bind(this));
	}

	prevClick() {
		this.flkty.previous();
	}
	nextClick() {
		this.flkty.next();
	}
	dotClick(i: number) {
		this.flkty.select(i);
	}
	dotEnter(index: number) {
		this.hoverIndex = index;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		this.DOM.dots[index].classList.add('js-active');
		if (this.DOM.hoverTitle) this.DOM.hoverTitle.innerHTML = this.data[index].title;
	}
	controlEnter() {
		this.hovering = true;
	}
	controlLeave() {
		this.hovering = false;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		this.DOM.dots[this.index].classList.add('js-active');
		if (this.DOM.hoverTitle) this.DOM.hoverTitle.innerHTML = this.data[this.index].title;
	}
	rotatorChange(index: number) {
		this.index = index;
		for (let i = 0; i < this.DOM.dots.length; i++) {
			this.DOM.dots[i].classList.remove('js-active');
		}
		if (index === this.DOM.dots.length - 1) {
			this.DOM.next!.disabled = true;
		} else {
			this.DOM.next!.disabled = false;
		}
		if (index === 0) {
			this.DOM.prev!.disabled = true;
		} else {
			this.DOM.prev!.disabled = false;
		}
		// if( this.players[this.playingVideo].plyr ){
		// 	this.players[this.playingVideo].plyr.pause()
		// }
		// if( this.players[index].plyr ){
		// 	this.players[index].plyr.play()
		// }
		// this.playingVideo = index

		if (this.hovering) return;
		this.DOM.dots[index].classList.add('js-active');
		if (this.DOM.hoverTitle) this.DOM.hoverTitle.innerHTML = this.data[index].title;
	}
}
customElements.define('flx-gallery', FF_FlexGallery);
